const fontFamily = [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
].join(',');


const typography = {
    fontFamily,
    button: {
        textTransform: 'none',
        fontWeight: 600,
    },
    // subtitle2: {
    //     fontWeight: 600,
    // },
    overline: {
        letterSpacing: 0.5,
    },
};

export default typography;
